"use client";

// src/index.ts
import { domAnimation } from "framer-motion";
var index_default = domAnimation;
export {
  index_default as default
};
